import angular from 'angular';

RedemptionLimitFilter.$inject = [];

/**
 * The coupons API uses null for "no limit", and a coupon created before redemption limits existed
 * may omit the field altogether. Both mean the coupon is unlimited.
 */
export function redemptionLimit(value?: number | null): number | string {
  if (value === null || value === undefined) {
    return 'No limit';
  }

  return value;
}

function RedemptionLimitFilter() {
  return redemptionLimit;
}

export const RedemptionLimitFilterModule = angular
  .module('acme.view.application.coupons.list.filter.redemptionLimit', [])
  .filter('redemptionLimit', RedemptionLimitFilter).name;
